var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#8f6398",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17C12.2833 17 12.521 16.904 12.713 16.712C12.905 16.52 13.0007 16.2827 13 16V13C13 12.7167 12.904 12.4793 12.712 12.288C12.52 12.0967 12.2827 12.0007 12 12C11.7167 12 11.4793 12.096 11.288 12.288C11.0967 12.48 11.0007 12.7173 11 13V16C11 16.2833 11.096 16.521 11.288 16.713C11.48 16.905 11.7173 17.0007 12 17ZM12 10C12.2833 10 12.521 9.904 12.713 9.712C12.905 9.52 13.0007 9.28267 13 9C13 8.71667 12.904 8.47933 12.712 8.288C12.52 8.09667 12.2827 8.00067 12 8C11.7167 8 11.4793 8.096 11.288 8.288C11.0967 8.48 11.0007 8.71733 11 9C11 9.28333 11.096 9.521 11.288 9.713C11.48 9.905 11.7173 10.0007 12 10ZM6 21C5.45 21 4.97933 20.8043 4.588 20.413C4.19667 20.0217 4.00067 19.5507 4 19V10C4 9.68333 4.071 9.38333 4.213 9.1C4.355 8.81667 4.55067 8.58333 4.8 8.4L10.8 3.9C11.15 3.63333 11.55 3.5 12 3.5C12.45 3.5 12.85 3.63333 13.2 3.9L19.2 8.4C19.45 8.58333 19.646 8.81667 19.788 9.1C19.93 9.38333 20.0007 9.68333 20 10V19C20 19.55 19.804 20.021 19.412 20.413C19.02 20.805 18.5493 21.0007 18 21H6Z",
    fill: "#8f6398"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp2);
export default __webpack_public_path__ + "static/media/Help2.f3a80ce082c55029915583ac53c8514c.svg";
export { ForwardRef as ReactComponent };